export default "__VITE_ASSET__3183ff62__"